class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    const desktopNavLinks = document.querySelectorAll(
      '[data-gtm-target-context="top-nav"] [data-gtm-nav-link]',
    )
    desktopNavLinks.forEach((el) => {
      el.addEventListener('click', this.handleDesktopNavClick.bind(this))
    })
  }

  handleDesktopNavClick (e) {
    e.stopImmediatePropagation()

    const target = e.currentTarget
    const targetContext = target.closest('[data-gtm-target-context]')
    const targetElement = target.closest('[data-gtm-target-element]')

    window.dataLayer.push({
      event: 'nav_link_click_desktop',
      target_text: target.dataset.gtmTargetText || target.innerText,
      target_context: targetContext?.dataset.gtmTargetContext,
      target_element: targetElement?.dataset.gtmTargetElement || 'link',
    })
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
